<template>
    <div id="component-report-sinister">

        <!--  Modal Quoter-->
        <div class="modal fade" id="show-quoter" tabindex="-1" role="dialog" aria-labelledby="quoterModal"
            aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="quoterModal"><strong class="text-dark">Detalle de
                                Cotización</strong></h5>
                        <button class="close" type="button" data-dismiss="modal" aria-label="Close"><span
                                aria-hidden="true">×</span></button>
                    </div>
                    <div class="modal-body">
                        <ul class="quoter_info" v-if="currentQuote">
                            <li v-if="currentQuote.num_asegurados">
                                <strong>Número de Asegurados: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ currentQuote.num_asegurados }}
                                </span>
                            </li>
                            <li v-if="currentQuote.costo_x_persona">
                                <strong>Costo x Persona: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(currentQuote.costo_x_persona) }}
                                </span>
                            </li>
                            <li v-if="currentQuote.costo_x_per_dcto">
                                <strong>Costo x Persona dcto: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(currentQuote.costo_x_per_dcto) }}
                                </span>
                            </li>
                            <li v-if="currentQuote.percent_iva">
                                <strong>Porcentaje de I.V.A: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(currentQuote.percent_iva) }}
                                </span>
                            </li>
                            <li v-if="currentQuote.prima_base">
                                <strong>Costo Base: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(currentQuote.prima_base) }}
                                </span>
                            </li>
                            <li v-if="currentQuote.extra_prima">
                                <strong>Extra Costo: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(currentQuote.extra_prima) }}
                                </span>
                            </li>
                            <li v-if="currentQuote.desc_fam">
                                <strong>Dcto. Familiar: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(currentQuote.desc_fam) }}
                                </span>
                            </li>
                            <li v-if="currentQuote.prima_neta">
                                <strong>Costo Neto: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(currentQuote.prima_neta) }}
                                </span>

                            </li>
                            <li v-if="currentQuote.gastos">
                                <strong>Gasto: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(currentQuote.gastos) }}
                                </span>
                            </li>
                            <li v-if="currentQuote.gasto_x_persona">
                                <strong>Gasto x Persona: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(currentQuote.gasto_x_persona) }}
                                </span>
                            </li>
                            <li v-if="currentQuote.anticipo">
                                <strong>Anticipo: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(currentQuote.anticipo) }}
                                </span>
                            </li>
                            <li v-if="currentQuote.descuento">
                                <strong>Descuento: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(currentQuote.descuento) }}
                                </span>
                            </li>
                            <li v-if="currentQuote.subtotal">
                                <strong>Subtotal: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(currentQuote.subtotal) }}</span>
                            </li>
                            <li v-if="currentQuote.iva">
                                <strong>I.V.A: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(currentQuote.iva) }}
                                </span>
                            </li>
                            <li v-if="currentQuote.prima_total">
                                <strong>Costo Total: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(currentQuote.prima_total) }}
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" type="button" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>

        <!--  Modal Quoter Workers -->
        <div class="modal fade" id="show-quoter-workers" tabindex="-1" role="dialog" aria-labelledby="quoterModal"
            aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="quoterModal"><strong class="text-dark">Detalle de
                                Cotización Afiliados</strong></h5>
                        <button class="close" type="button" data-dismiss="modal" aria-label="Close"><span
                                aria-hidden="true">×</span></button>
                    </div>
                    <div class="modal-body">
                        <ul class="quoter_worker_info" v-if="extraUserQuotes">
                            <li class="row">
                                <span class="col title-table">Fecha de Cotización</span>
                                <span class="col title-table"># de Afiliados</span>
                                <span class="col title-table">Meses de Diferencia</span>
                                <span class="col title-table">Costo Neto</span>
                                <span class="col title-table">Gasto Total</span>
                                <span class="col title-table">I.V.A</span>
                                <span class="col title-table">Costo Total</span>
                                <span class="col title-table">Aprobado el</span>
                            </li>
                            <li class="row item-quoter" v-for="(extraQuote, index) in extraUserQuotes" :key="index">
                                <div class="col">{{ formatDate(extraQuote.created_at) }}</div>
                                <div class="col">{{ extraQuote.num_workers }}</div>
                                <div class="col">{{ extraQuote.diff_months }}</div>
                                <div class="col">{{ formatPrice(extraQuote.total_cost_per_person) }}</div>
                                <div class="col">{{ formatPrice(extraQuote.total_expense_per_person) }}</div>
                                <div class="col">{{ extraQuote.iva }}</div>
                                <div class="col">{{ formatPrice(extraQuote.total_cost) }}</div>
                                <div class="col">{{ extraQuote.approved_at }}</div>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" type="button" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>

        <!--  Modal Specialist -->
        <div class="modal fade" id="show-modal-specialist" tabindex="-1" role="dialog" aria-labelledby="quoterModal"
            aria-hidden="true">
            <div class="modal-dialog modal-fullscreen" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="quoterModal">
                            <strong class="text-dark">Detalle Especialistas</strong>
                        </h5>
                        <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- TABLA DE SINIESTROS POR ESPECIALISTAS  -->
                        <div v-for="(specialistData, specialistId) in sinistersSpecialist" :key="specialistId">

                            <div class="view">
                                <div class="row">
                                    <div class="col">
                                        <h5>
                                            {{ specialistData[0].supplier.nom_com }}
                                        </h5>
                                    </div>
                                    <div class="col">
                                        <span class="float-end badge rounded-pill text-bg-blue">
                                            Total: {{ calculateTableTotal(specialistData) }}
                                        </span>
                                    </div>
                                    <div class="col">
                                        <button type="button" class="float-end badge rounded-pill text-bg-blue"
                                            @click="updateTableVisible(specialistId)">
                                            Ver Siniestros <i class="fa-solid fa-circle-chevron-down"></i>
                                        </button>
                                    </div>
                                </div>

                                <table class="table table-striped mt-2" v-show="tableVisible[specialistId]">
                                    <thead>
                                        <tr>
                                            <th>Fecha de atención</th>
                                            <th>Membresia</th>
                                            <th>Descripción</th>
                                            <th>Honorarios</th>
                                            <th>I.S.R</th>
                                            <th>Costo Consulta</th>
                                            <th>1.6%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(sinister, index) in specialistData" :key="index">
                                            <td>{{ formatDate(sinister.fecha_atencion) }}</td>
                                            <td>{{ sinister.sku }}</td>
                                            <td v-html="sinister.diagnosis"></td>
                                            <td>{{ formatPrice(specialistData[0].supplier.honorarios) }}</td>
                                            <td>{{ formatPrice(specialistData[0].supplier.isr) }}</td>
                                            <td>
                                                {{
                                                    formatPrice(calculateTotal(specialistData[0].supplier.honorarios,
                                                        specialistData[0].supplier.isr))
                                                }}
                                            </td>
                                            <td>{{ calculateTotalOneSixColumn(specialistData[0].supplier.honorarios) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="5"></td>
                                            <td><strong>Total</strong></td>
                                            <td><strong>{{ calculateTableTotal(specialistData) }}</strong></td>
                                        </tr>
                                    </tbody>
                                </table>


                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" type="button" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>

        <!--  Modal Dentist  -->
        <div class="modal fade" id="show-modal-dentist" tabindex="-1" role="dialog" aria-labelledby="quoterModal"
            aria-hidden="true">
            <div class="modal-dialog modal-fullscreen" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="quoterModal">
                            <strong class="text-dark">Detalle Dentista</strong>
                        </h5>
                        <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-for="(dentistData, dentistId) in sinistersDentist" :key="dentistId">

                            <div class="view">
                                <div class="row">
                                    <div class="col">
                                        <h5>
                                            {{ dentistData[0].supplier.proveedor }}
                                        </h5>
                                    </div>
                                    <div class="col">
                                        <span class="float-end badge rounded-pill text-bg-blue">
                                            <!--  Total: {{ calculateTableTotal(sinistersDentist) }}-->
                                        </span>
                                    </div>
                                    <div class="col">
                                        <button type="button" class="float-end badge rounded-pill text-bg-blue"
                                            @click="updateTableVisible(dentistId)">
                                            Ver Siniestros <i class="fa-solid fa-circle-chevron-down"></i>
                                        </button>
                                    </div>
                                </div>

                                <table class="table table-striped mt-2" v-show="tableVisible[dentistId]">
                                    <thead>
                                        <tr>
                                            <th>Fecha de atención</th>
                                            <th>Membresia</th>
                                            <th>Descripción</th>
                                            <th>Honorarios</th>
                                            <th>I.S.R</th>
                                            <th>Costo Consulta</th>
                                            <th>1.6%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(sinister, index) in dentistData" :key="index">
                                            <td>{{ formatDate(sinister.fecha_atencion) }}</td>
                                            <td>{{ sinister.sku }}</td>
                                            <td v-html="sinister.diagnosis"></td>
                                            <td>{{ formatPrice(dentistData[0].supplier.honorarios) }}</td>
                                            <td>{{ formatPrice(dentistData[0].supplier.isr) }}</td>
                                            <td>{{
                                                formatPrice(calculateTotal(dentistData[0].supplier.honorarios,
                                                    dentistData[0].supplier.isr))
                                            }}
                                            </td>
                                            <td>{{ calculateTotalOneSixColumn(dentistData[0].supplier.honorarios) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="5"></td>
                                            <td><strong>Total</strong></td>
                                            <td><strong>{{ calculateTableTotal(dentistData) }}</strong></td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" type="button" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>

        <!--  Modal Hospital Gral -->
        <div class="modal fade" id="show-modal-hospital" tabindex="-1" role="dialog" aria-labelledby="quoterModal"
            aria-hidden="true">
            <div class="modal-dialog modal-fullscreen" role="document">
                <div class="modal-content" v-if="selectedHospital">
                    <div class="modal-header">
                        <h5 class="modal-title" id="quoterModal">
                            <strong class="text-dark">
                                Detalle {{
                                    selectedHospital.key
                                        .split('_')
                                        .slice(1)
                                        .join(' ')
                                        .replace(/\b\w/g, l => l.toUpperCase())
                                }}
                            </strong>
                        </h5>
                        <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-for="(conceptArray, conceptName) in selectedHospital" :key="conceptName">
                            <!-- Solo mostrar si hay registros en el concepto -->
                            <div v-if="Array.isArray(conceptArray) && conceptArray.length > 0">
                                <div class="row view">
                                    <div class="col">
                                        <h5>{{ formatArrayName(conceptName) }}</h5>
                                    </div>
                                    <div class="col">
                                        <span class="float-end badge rounded-pill text-bg-blue">
                                            Total: {{ calculateTableTotalColumn({ [conceptName]: conceptArray }) }}
                                        </span>
                                    </div>
                                    <div class="col">
                                        <button type="button" class="float-end badge rounded-pill text-bg-blue"
                                            @click="updateTableVisible(conceptName)">
                                            Ver Siniestros <i class="fa-solid fa-circle-chevron-down"></i>
                                        </button>
                                    </div>
                                    <table class="table table-striped mt-2" v-show="tableVisible[conceptName]">
                                        <thead>
                                            <tr>
                                                <th>Fecha de atención</th>
                                                <th>Membresia</th>
                                                <th>Diagnostico</th>
                                                <th>Cantidad</th>
                                                <th>Precio Tabulador</th>
                                                <th>Subtotal</th>
                                                <th>8%</th>
                                                <th>Total</th>
                                                <th>1.6%</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(sinister, index) in conceptArray" :key="index">
                                                <td>{{ formatDate(sinister.fecha) }}</td>
                                                <td>{{ sinister.membresia }}</td>
                                                <td v-html="sinister.diagnosis"></td>
                                                <td>{{ formatPrice(sinister.cantidad) }}</td>
                                                <td>{{ formatPrice(sinister.precio_tabulador) }}</td>
                                                <td>{{ formatPrice(sinister.subtotal) }}</td>
                                                <td>{{ sinister.ocho_iva ? formatPrice(sinister.ocho_iva) : 'N/A' }}
                                                </td>
                                                <td>{{ formatPrice(sinister.total) }}</td>
                                                <td>{{ formatPrice(sinister.one_six_red) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" type="button" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>

        <!--  Modal Laboratory-->
        <div class="modal fade" id="show-modal-laboratory" tabindex="-1" role="dialog" aria-labelledby="quoterModal"
            aria-hidden="true">
            <div class="modal-dialog modal-fullscreen" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="quoterModal">
                            <strong class="text-dark">Detalle Laboratorios</strong>
                        </h5>
                        <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-for="(sinisterData, sinisterModel) in sinisterRecords">
                            <div v-for="(data, index) in sinisterData" :key="index">
                                <div v-if="index !== '1'">
                                    <div class="row view">
                                        <div class="col">
                                            <h5>{{ data[0].model_id.proveedor }}</h5>
                                        </div>
                                        <div class="col">
                                            <span class="float-end badge rounded-pill text-bg-blue">
                                                Total: {{ calculateTableTotalLab(data) }}
                                            </span>
                                        </div>
                                        <div class="col">
                                            <button type="button" class="float-end badge rounded-pill text-bg-blue"
                                                @click="updateTableVisible(index)">
                                                Ver Siniestros <i class="fa-solid fa-circle-chevron-down"></i>
                                            </button>
                                        </div>
                                        <table class="table table-striped mt-2" v-show="tableVisible[index]">
                                            <thead>
                                                <tr>
                                                    <th>Fecha de atención</th>
                                                    <th>Membresia</th>
                                                    <th>Servicio Lab.</th>
                                                    <th>Cantidad</th>
                                                    <th>1.6%</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(sinister, index) in data" :key="index">
                                                    <td>{{ formatDate(sinister.fecha) }}</td>
                                                    <td>{{ sinister.membresia }}</td>
                                                    <td>{{ sinister.laboratory_service_catalog.name }}</td>
                                                    <td>{{ sinister.cantidad }}</td>
                                                    <td>{{ formatPrice(sinister.one_six_red) }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3"></td>
                                                    <td><strong>Total</strong></td>
                                                    <td><strong>{{ calculateTableTotalLab(data) }}</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" type="button" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>

        <!--  Modal Maria Isabel-->
        <div class="modal fade" id="show-modal-mi" tabindex="-1" role="dialog" aria-labelledby="quoterModal"
            aria-hidden="true">
            <div class="modal-dialog modal-fullscreen" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="quoterModal">
                            <strong class="text-dark">Detalle Maria Isabel</strong>
                        </h5>
                        <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-for="(arrayData, arrayName) in laboratoryRecords" :key="arrayData.id">
                            <div class="row view">
                                <div class="col">
                                    <h5>{{ formatArrayName(arrayName) }}</h5>
                                </div>
                                <div class="col">
                                    <span class="float-end badge rounded-pill text-bg-blue">
                                        Total: {{ calculateTableTotalLab(arrayData) }}
                                    </span>
                                </div>
                                <div class="col">
                                    <button type="button" class="float-end badge rounded-pill text-bg-blue"
                                        @click="updateTableVisible(arrayName)">
                                        Ver Siniestros <i class="fa-solid fa-circle-chevron-down"></i>
                                    </button>
                                </div>
                                <table class="table table-striped mt-2" v-show="tableVisible[arrayName]">
                                    <thead>
                                        <tr>
                                            <th>Fecha de atención</th>
                                            <th>Membresia</th>
                                            <th>Servicio Lab.</th>
                                            <th>Cantidad</th>
                                            <th>Precio tabulador</th>
                                            <th>Subtotal</th>
                                            <th>I.v.a</th>
                                            <th>Total</th>
                                            <th>1.6%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(sinister, index) in arrayData" :key="index">
                                            <td>{{ formatDate(sinister.fecha) }}</td>
                                            <td>{{ sinister.membresia }}</td>
                                            <td>{{ sinister.laboratory_service_catalog.name }}</td>
                                            <td>{{ sinister.cantidad }}</td>
                                            <td>{{ sinister.precio_tabulador }}</td>
                                            <td>{{ sinister.subtotal }}</td>
                                            <td>{{ sinister.one_six_iva }}</td>
                                            <td>{{ sinister.total }}</td>
                                            <td>{{ formatPrice(sinister.one_six_red) }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="7"></td>
                                            <td><strong>Total</strong></td>
                                            <td><strong>{{ calculateTableTotalLab(arrayData) }}</strong></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" type="button" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>

        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="row">
                    <div class="col-12 col-sm-3">
                        <select v-model="selectedClientIndex" @change="showQuoting()">
                            <option :value="null">Selecciona un cliente</option>
                            <option v-for="(client, index) in clients" :key="client.id" :value="index">
                                <span v-if="client.tipo_per === 1" class="fisica">
                                    {{ client.sku }} - {{ client.nombre }} {{ client.paterno }} {{ client.materno }}
                                </span>
                                <span v-else class="moral">
                                    {{ client.sku }} - {{ client.nmComPerMoral }}
                                </span>
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-sm-3">
                        <select v-model="report.rango_vigencia">
                            <option :value="0">Selecciona un rango de fechas</option>
                            <option v-for="(contract, index) in historyContracts" :key="index"
                                :value="{ start: contract.start_date, end: contract.expiration_date }">
                                {{ contract.start_date }} - {{ contract.expiration_date }}
                            </option>
                        </select>
                        <!-- <date-picker
                            input-class="mx-input scr-input"
                            v-model="report.rango_vigencia"
                            format="YYYY-MM-dd"
                            range placeholder="Fecha de vigencia"
                            lang="es"></date-picker>-->
                    </div>
                    <div class="col-12 col-sm-2">
                        <button class="formSubmit" @click="createReport()" :disabled="isGeneratingReport">
                            {{ isGeneratingReport ? 'Generando Reporte...' : 'Generar reporte' }}
                        </button>

                    </div>
                    <div class="col-12 col-sm-2">
                        <a class="formSubmit" v-if="xlsReportFileName" :href="xlsReportFileName" download>
                            <i class="fa fa-file-excel"></i> Descargar XLS
                        </a>
                    </div>
                    <div class="col-12 col-sm-2">
                        <a class="formSubmit" href="/reporte-historial-xls">
                            <i class="fa-solid fa-clock-rotate-left"></i> Hist. de Reportes
                        </a>
                    </div>
                </div>
            </div>
            <div class="row tables_equal">
                <div class="col-12 col-sm-4" v-if="currentQuote">
                    <div class="view showQuoting">
                        <h5>Cotización Actual</h5>
                        <ul class="quoter_info">
                            <li v-if="currentQuote.prima_total">
                                <strong>Costo Total: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(currentQuote.prima_total) }}
                                </span>
                            </li>
                        </ul>
                        <button class="formSubmit m-1" type="button" data-toggle="modal" data-target="#show-quoter"
                            title="Ver Detalle de cotización">
                            <i class="fa fa-tag text-white mr-2"></i> Ver detalle
                        </button>
                    </div>
                </div>
                <div class="col-12 col-sm-4" v-if="extraUserQuotes">
                    <div class="view showQuoting">
                        <h5>Altas subsecuentes</h5>
                        <ul class="quoter_info">
                            <li>
                                <strong>Total de Cotizaciones: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ totalCostSum() }}
                                </span>
                            </li>
                        </ul>
                        <button class="formSubmit m-1" type="button" data-toggle="modal"
                            data-target="#show-quoter-workers" title="Ver Detalle de cotización">
                            <i class="fa fa-tag text-white mr-2"></i> Ver detalle
                        </button>
                    </div>
                </div>
                <div class="col-12 col-sm-4" v-if="globalSumSpecialist !== 0">
                    <div class="view showQuoting">
                        <h5>Siniestros con Especialistas</h5>
                        <ul class="quoter_info">
                            <li>
                                <strong>Total acumulativo: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(globalSumSpecialist) }}
                                </span>
                            </li>
                        </ul>
                        <button class="formSubmit m-1" type="button" data-toggle="modal"
                            data-target="#show-modal-specialist" title="Ver Detalle de siniestros">
                            <i class="fa fa-tag text-white mr-2"></i> Ver detalle
                        </button>
                    </div>
                </div>
                <div class="col-12 col-sm-4" v-if="globalSumDentist !== 0">
                    <div class="view showQuoting">
                        <h5>Siniestros con Dentistas</h5>
                        <ul class="quoter_info">
                            <li>
                                <strong>Total acumulativo: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(globalSumDentist) }}
                                </span>
                            </li>
                        </ul>
                        <button class="formSubmit m-1" type="button" data-toggle="modal"
                            data-target="#show-modal-dentist" title="Ver Detalle de siniestros">
                            <i class="fa fa-tag text-white mr-2"></i> Ver detalle
                        </button>
                    </div>
                </div>
                <!-- Hospitales dinámicos -->

                <div class="col-12 col-sm-4" v-for="hospital in hospitales" :key="hospital.key">
                    <div class="view showQuoting">
                        <h5>
                            Siniestros en
                            {{
                                hospital.key
                                    .split('_')
                                    .slice(1)
                                    .join(' ')
                                    .replace(/\b\w/g, l => l.toUpperCase())
                            }}
                        </h5>
                        <ul class="quoter_info">
                            <li>
                                <strong>Total acumulativo: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ calculateGlobalSumHospital(hospital) }}
                                </span>
                            </li>
                        </ul>
                        <button class="formSubmit m-1" type="button" data-toggle="modal"
                            data-target="#show-modal-hospital" :title="'Ver Detalle de siniestros en ' + hospital.key"
                            @click="selectedHospital = hospital">
                            <i class="fa fa-tag text-white mr-2"></i> Ver detalle
                        </button>
                    </div>
                </div>
                <div class="col-12 col-sm-4" v-if="globalSumLaboratory !== 0">
                    <div class="view showQuoting">
                        <h5>Siniestros en Laboratorios</h5>
                        <ul class="quoter_info">
                            <li>
                                <strong>Total acumulativo: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(globalSumLaboratory) }}
                                </span>
                            </li>
                        </ul>
                        <button class="formSubmit m-1" type="button" data-toggle="modal"
                            data-target="#show-modal-laboratory" title="Ver Detalle de siniestros">
                            <i class="fa fa-tag text-white mr-2"></i> Ver detalle
                        </button>
                    </div>
                </div>
                <div class="col-12 col-sm-4" v-if="globalSumMariaIsabelLC !== 0">
                    <div class="view showQuoting">
                        <h5>Siniestros en Maria Isabel</h5>
                        <ul class="quoter_info">
                            <li>
                                <strong>Total acumulativo: </strong>
                                <span class="float-end badge rounded-pill text-bg-blue">
                                    {{ formatPrice(globalSumMariaIsabelLC) }}
                                </span>
                            </li>
                        </ul>
                        <button class="formSubmit m-1" type="button" data-toggle="modal" data-target="#show-modal-mi"
                            title="Ver Detalle de siniestros">
                            <i class="fa fa-tag text-white mr-2"></i> Ver detalle
                        </button>
                    </div>
                </div>
            </div>
        </main>

    </div>
</template>

<script>
import { myMixins } from "../mixins/myMixins";
import { clientsService } from "../../Services/Clients.service";
import { reportService } from "../../Services/Reports";

export default {
    name: "report-sinisters",
    mixins: [myMixins],
    components: {
        DatePicker: () => import('vue2-datepicker'),
    },
    data() {
        return {
            selectedHospital: null,
            clients: [],
            client: 0,
            consulta_ginecologica_mi: [],
            consulta_pediatria_mi: [],
            consulta_general_mi: [],
            laboratorios_mi: [],
            currentQuote: '',
            extraUserQuotes: '',
            globalSumDentist: 0,
            globalSumSpecialist: 0,
            globalSumHospitalSanJoses: 0,
            globalSumLaboratory: 0,
            globalSumMariaIsabelLC: 0,
            historyContracts: [],
            isBusy: false,
            isGeneratingReport: false,
            hospitales: [],
            report: {
                client: 0,
                rango_vigencia: 0,
            },
            reports: [],
            selectedClient: null,
            selectedClientIndex: null,
            sinistersDentist: [],
            sinistersSpecialist: [],
            sinistersHospitals: [],
            sinisterRecords: [],
            tableVisible: [],
            totalSum: 0,
            xlsReportFileName: '',
        }
    },
    methods: {
        calculateInnerArrayTotals(columnData) {
            let innerArrayTotals = {};

            // Iterar sobre cada productService en la columna
            for (let productServiceSlug in columnData) {
                let productServiceArray = columnData[productServiceSlug];
                let totalSum = 0;

                // Iterar sobre cada registro en el productService
                for (let sinister of productServiceArray) {
                    totalSum += Number(sinister.one_six_red);
                }

                // Guardar la suma total en innerArrayTotals
                innerArrayTotals[productServiceSlug] = this.formatPrice(totalSum);
            }

            return innerArrayTotals;
        },
        calculateTableTotalColumn(columnData) {
            let totalSum = 0;
            for (let productServiceArray of Object.values(columnData)) {
                if (Array.isArray(productServiceArray)) {
                    for (let sinister of productServiceArray) {
                        totalSum += Number(sinister.one_six_red);
                    }
                }
            }
            return this.formatPrice(totalSum);
        },
        calculateTableTotalLab(data) {
            let _totalSum = 0;
            for (let sinister of data) {
                //// console.log(sinister.one_six_red);
                _totalSum += Number(sinister.one_six_red);
            }
            return this.formatPrice(_totalSum);
        },
        calculateTableTotal(data) {
            let totalSum = 0;
            for (let sinister of data) {
                totalSum += this.calculateTotal(data[0].supplier.honorarios, data[0].supplier.isr);
            }
            return this.formatPrice(totalSum);
        },
        calculateTotal(honorarios, isr) {
            return honorarios - (honorarios * isr);
        },
        calculateTotalOneSixColumn(honorarios) {
            return (honorarios * 1.6);
        },
        calculateGlobalSumHospital(hospitalData) {
            let totalSum = 0;
            // Recorre todas las categorías del hospital
            for (const categoryKey in hospitalData) {
                const category = hospitalData[categoryKey];
                // Si la categoría es un array, suma los one_six_red
                if (Array.isArray(category)) {
                    for (const item of category) {
                        if (item && item.one_six_red) {
                            totalSum += Number(item.one_six_red);
                        }
                    }
                }
                // Si la categoría es un objeto (por ejemplo, servicios_de_radiologia puede ser un objeto con arrays dentro)
                else if (typeof category === 'object' && category !== null) {
                    for (const subKey in category) {
                        const subArray = category[subKey];
                        if (Array.isArray(subArray)) {
                            for (const item of subArray) {
                                if (item && item.one_six_red) {
                                    totalSum += Number(item.one_six_red);
                                }
                            }
                        }
                    }
                }
            }
            return this.formatPrice(totalSum);
        },
        calculateGlobalSumLaboratory(arrayLaboratory) {
            let _totalSum = 0;
            this.globalSumLaboratory = 0;
            for (let [modelType, modelData] of Object.entries(arrayLaboratory)) {
                if (modelType !== '1') {
                    for (let data of Object.values(modelData)) {
                        _totalSum = 0;
                        if (Array.isArray(data)) {
                            for (let sinister of data) {
                                this.globalSumLaboratory += Number(sinister.one_six_red);
                            }
                        }
                    }
                }
            }
        },
        calculateGlobalSumSinistersSpecialist(arraySpecialist) {
            let _totalSum = 0;
            this.globalSumSpecialist = 0;
            for (let specialistData of Object.values(arraySpecialist)) {
                //// console.log('specialistData', specialistData);
                _totalSum = 0;
                for (let sinister of specialistData) {
                    _totalSum += this.calculateTotal(Number(sinister.supplier.honorarios), Number(sinister.supplier.isr));
                }
                this.globalSumSpecialist += _totalSum;
            }
            return this.formatPrice(this.globalSumSpecialist);
        },
        calculateGlobalSumSinistersDentist(arrayDentist) {
            // Verificar si arrayDentist es un objeto y no está vacío ni indefinido
            if (typeof arrayDentist !== 'object' || arrayDentist === null || Object.keys(arrayDentist).length === 0) {
                this.globalSumDentist = 0;
                return this.formatPrice(0);
            }
            let _totalSum = 0;
            this.globalSumDentist = 0;
            for (let specialistData of Object.values(arrayDentist)) {
                _totalSum = 0;
                for (let sinister of specialistData) {
                    _totalSum += this.calculateTotal(Number(sinister.supplier.honorarios), Number(sinister.supplier.isr));
                }
                this.globalSumDentist += _totalSum;
            }
        },
        calculateGlobalSumMariaIsabelLC(objectMariaIsabelLC) {
            // Verificar si objectMariaIsabelLC es undefined
            if (!objectMariaIsabelLC) {
                this.globalSumMariaIsabelLC = 0;
                return this.formatPrice(0);
            }

            // Obtener los cuatro arrays del objeto
            let arraysMariaIsabelLC = Object.values(objectMariaIsabelLC);

            // Inicializar la suma global
            this.globalSumMariaIsabelLC = 0;

            // Recorrer cada array y sumar sus valores
            for (let arrayMariaIsabelLC of arraysMariaIsabelLC) {
                this.globalSumMariaIsabelLC += arrayMariaIsabelLC.reduce((sum, sinister) => sum + Number(sinister.one_six_red), 0);
            }

            return this.formatPrice(this.globalSumMariaIsabelLC);
        },
        formatArrayName(name) {
            let formattedName = name.replace(/_/g, ' ');
            return formattedName.charAt(0).toUpperCase() + formattedName.slice(1);
        },
        flattenArrayHospitalSanJoses(arrayHospitalSanJoses) {
            // Aplanar todos los arrays internos en un solo array
            return [].concat(...Object.values(arrayHospitalSanJoses).filter(val => Array.isArray(val)));
        },
        splitSinisterRecords() {
            let recordsByModelType = {};

            for (let modelType in this.sinisterRecords) {
                recordsByModelType[modelType] = {};

                for (let modelId in this.sinisterRecords[modelType]) {
                    if (modelId === '1') {
                        recordsByModelType[modelType][modelId] = {
                            consulta_ginecologica: [],
                            consulta_pediatria: [],
                            consulta_general: [],
                            laboratorios: []
                        };

                        for (let record of this.sinisterRecords[modelType][modelId]) {
                            switch (record.laboratory_service_catalog_id) {
                                case 632:
                                    recordsByModelType[modelType][modelId].consulta_ginecologica.push(record);
                                    break;
                                case 633:
                                    recordsByModelType[modelType][modelId].consulta_pediatria.push(record);
                                    break;
                                case 634:
                                    recordsByModelType[modelType][modelId].consulta_general.push(record);
                                    break;
                                default:
                                    recordsByModelType[modelType][modelId].laboratorios.push(record);
                                    break;
                            }
                        }
                    } else {
                        recordsByModelType[modelType][modelId] = this.sinisterRecords[modelType][modelId];
                    }
                }
            }

            this.sinisterRecords = recordsByModelType;
        },
        totalCostSum() {
            if (Array.isArray(this.extraUserQuotes)) {
                let sum = this.extraUserQuotes.reduce((sum, extraQuote) => sum + parseFloat(extraQuote.total_cost), 0);
                return this.formatPrice(sum);
            }
            return this.formatPrice(0);
        },
        showQuoting() {
            if (this.selectedClientIndex !== null) {
                this.selectedClient = this.clients[this.selectedClientIndex];
                ////console.log(selectedClient.relquoting);
                this.currentQuote = this.selectedClient.relquoting;
                this.extraUserQuotes = this.selectedClient.extrauserquotes;
                this.report.client = this.selectedClient.id;
                //this.report.rango_vigencia = [selectedClient.expirationcontract.start_date,selectedClient.expirationcontract.expiration_date]
                this.historyContracts = this.selectedClient.expiration_contract_history;
                // Asignar los siniestros relacionados a las nuevas variables
            }
        },
        updateTableVisible(index) {
            ////console.log('index- ', index);
            this.$set(this.tableVisible, index, !this.tableVisible[index]);
        },
        async createReport() {
            this.isGeneratingReport = true;
            try {
                let collectionSinisters = '';
                this.sinistersDentist = [];
                this.sinistersSpecialist = [];
                this.sinistersHospitals = [];
                this.sinisterRecords = [];

                // Obtener los siniestros del cliente
                collectionSinisters = await reportService.getSinistersBySkuAndDateRange(this.report);
                //console.log('collectionSinisters - ', collectionSinisters);

                //ARRAY DE SPECIALISTS
                this.sinistersSpecialist = collectionSinisters.sinistersSpecialist["App\\Models\\Specialist"];
                if (this.sinistersSpecialist !== undefined && Object.keys(this.sinistersSpecialist).length > 0) {
                    this.calculateGlobalSumSinistersSpecialist(this.sinistersSpecialist);
                }


                //ARRAY DE DENTISTS
                this.sinistersDentist = collectionSinisters.sinistersSpecialist["App\\Models\\Dentist"];
                ////console.log('this.sinistersDentist - ', this.sinistersDentist)
                if (this.sinistersDentist !== undefined && Object.keys(this.sinistersDentist).length > 0) {
                    this.calculateGlobalSumSinistersDentist(this.sinistersDentist);
                }

                //ARRAY DE HOSPITAL SAN JOSE
                this.sinistersHospitals = collectionSinisters.hospitales;
                if (this.sinistersHospitals !== undefined && Object.keys(this.sinistersHospitals).length > 0) {
                    // Convierte el objeto a un array de objetos con la clave como propiedad
                    this.hospitales = Object.entries(this.sinistersHospitals).map(([key, value]) => ({
                        key,
                        ...value
                    }));
                } else {
                    this.hospitales = [];
                }
                // ...existing code...

                //ARRAY DE LABORATORIES AQUI VAMOS A SACAR LAS CONSULTAS DE MARIA ISABEL POR QUE TAMBIEN DAN CONSULTAS
                //PARA ESO SE VAN A SEPARAR EN DOS ARRAYS UNO DE SERVICIOS DE CONSULTAS Y OTRO DE SERVICIOS DE LABORATORIOS
                //LAS CONSULTAS TIENEN LOS ID 632- CONSULTA GINECOLOGICA Y 633- CONSULTA PEDIATRICA Y 634- CONSULTA GENERAL
                this.sinisterRecords = collectionSinisters.sinistersRecords;
                ////console.log('BEFORE SPLIT splitSinisterRecords - ', this.sinisterRecords);
                this.splitSinisterRecords();
                ////console.log('AFTER SPLIT splitSinisterRecords - ', this.sinisterRecords);
                this.calculateGlobalSumLaboratory(this.sinisterRecords);

                //MARIA ISABEL CONSULTAS GENERALES
                if (this.sinisterRecords["App\\Models\\Laboratory"] !== undefined) {
                    let consultaGeneralData = this.sinisterRecords["App\\Models\\Laboratory"][1];
                    ////console.log('consultaGeneralData - ', consultaGeneralData);
                    this.globalSumMariaIsabelLC = this.calculateGlobalSumMariaIsabelLC(consultaGeneralData);
                }
                //ENVIA LOS DATOS PARA GENERAR EL REPORTE EN EXCEL
                let globalSumXls = {
                    globalSumDentist: this.globalSumDentist,
                    globalSumSpecialist: this.globalSumSpecialist,
                    globalSumHospitalSanJoses: this.globalSumHospitalSanJoses,
                    globalSumLaboratory: this.globalSumLaboratory,
                    globalSumMariaIsabelLC: this.globalSumMariaIsabelLC,
                }
                await this.generateXlsReport(this.selectedClient, this.sinistersSpecialist, this.sinistersDentist, this.sinistersHospitals, this.sinisterRecords, globalSumXls);

            } catch (error) {
                console.error(error);
            } finally {
                this.isGeneratingReport = false;
            }
            //Asignar los siniestros a las variables
        },
        async generateXlsReport(_selectedClient, _sinistersSpecialist, _sinistersDentist, _sinistersHospitals, _sinisterRecords, _globalSumXls) {
            this.isBusy = true;
            this.report.selectedClients = _selectedClient;
            this.report.sinistersSpecialists = _sinistersSpecialist;
            this.report.sinistersDentists = _sinistersDentist;
            this.report.sinistersHospitals = _sinistersHospitals;
            this.report.sinisterRecords = _sinisterRecords;
            this.report.globalSumXls = _globalSumXls;
            //console.log('the report', this.report);
            this.xlsReportFileName = await reportService.generateXlsReport(this.report);
            //console.log(this.xlsReportFileName);
        },
        async index() {
            this.clients = await clientsService.getMany();

        },
    },
    computed: {
        laboratoryRecords() {
            if (this.sinisterRecords && this.sinisterRecords['App\\Models\\Laboratory']) {
                return this.sinisterRecords['App\\Models\\Laboratory'][1];
            }
            return {};
        },

    },
    mounted() {
        this.index();
    }
}
</script>

<style scoped>
a:hover {
    color: #fff;
}

button[type="button"] {
    border: none;
}

.text-bg-blue {
    font-weight: bold !important;
}
</style>
